import { render, staticRenderFns } from "./ShiftDetailsSheet.vue?vue&type=template&id=5cd6c651&"
import script from "./ShiftDetailsSheet.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ShiftDetailsSheet.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports